import { get } from 'lodash/fp';
import isValidTargetItem from '../../components/CopyStylesModal/isValidTargetItem';
import actionTypes from './index';

const validateTargetItems = (itemId, result) => ({
  type: actionTypes.VALIDATION,
  payload: { itemId, result },
});

const validateItems = (sourceItemId, itemId) => async (dispatch, getState) => {
  const targetItem = get(`entities.items.byId.${itemId}`, getState().estimateBuilder);
  const validationResult = await isValidTargetItem(sourceItemId, targetItem);
  dispatch(validateTargetItems(itemId, validationResult));
};

export default validateItems;

